import { z } from "zod";
import api from "./api";
import { toast } from "../components/ui/use-toast";

const inputSchema = z.object({
  header: z.string(),
  description: z.string(),
  answer_type: z.string(),
});

export async function editQuestion(
  documentId: string,
  questionId: string,
  data: Partial<z.infer<typeof inputSchema>>,
) {
  try {
    const result = inputSchema.safeParse(data);
    if (!result.success) {
      throw new Error(result.error.errors[0].message);
    }
    const response = await api.put(
      `/documents/${documentId}/questions/${questionId}`,
      data,
    );
    if (response.status > 299) {
      throw new Error("Failed to add new question");
    }

    toast({
      title: "Question updated",
      description: "The question has been updated successfully",
    });

    return response.data;
  } catch (error) {
    console.error("Failed to create template:", error);
    return null;
  }
}
